<template>
  <button
    v-if="editable"
    :class="cssClass"
    type="button"
    aria-haspopup="dialog"
    class="profile-status profile-status--btn"
    @click="$emit('edit')"
  >
    <i
      v-if="descriptor"
      :class="descriptor.icon"
    />
    <span>{{ text }}</span>
    <i class="exu-chevron-down profile-status__chevron" />
  </button>
  <div
    v-else-if="descriptor"
    :class="cssClass"
    class="profile-status"
  >
    <i :class="descriptor.icon" />
    <span>{{ text }}</span>
  </div>
</template>

<script>
import { findStatus } from '@/components/mixins/participantStatusList';

export default {
  name: 'ProfileStatus',
  props: {
    // код статуса или null — набор в participantStatusList.js
    status: {
      type: String,
      default: null,
    },
    // в своём профиле пилюля нажимается и открывает выбор, в чужом — нет
    editable: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['edit'],
  computed: {
    // незнакомый код и пустая строка дают null — показываем как «без статуса»
    descriptor() {
      return findStatus(this.status);
    },
    text() {
      return this.descriptor
        ? this.$t(this.descriptor.labelKey)
        : this.$t('shared.participantStatus.choose');
    },
    cssClass() {
      return {
        'profile-status--muted': !this.descriptor || this.descriptor.code === 'do_not_disturb',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

// Пилюля живёт в шапке профиля, на синем. Фон сплошной белый, а не
// полупрозрачный как у соседнего .activity-tag: статус должен быть прочитан
// раньше, чем к человеку обратятся, а полупрозрачная плашка на узорном фоне
// теряется. Заодно сплошная заливка читается как «сюда можно нажать».
//
// Цветом статусы не различаются: их четыре, и раскрашивать пришлось бы все,
// а красный на «Не беспокоить» читался бы как ошибка — человек не ошибся,
// он попросил не писать. Различают иконка и слово.
.profile-status {
  display: inline-flex;
  align-items: center;
  // шапка — колоночный флекс без align-items, и без этого пилюлю растянуло бы
  // во всю ширину
  align-self: center;
  gap: 8px;
  padding: 5px 14px;
  border: none;
  border-radius: 14px;
  background: $color-base;
  color: $color-primary;
  font-size: 14px;
  line-height: 1.3em;

  & > i {
    font-size: 16px;
  }

  &--btn {
    cursor: pointer;
  }

  // «Не беспокоить» и приглашение выбрать статус — приглушены надписью, а не
  // фоном: гасить фон значит топить плашку в шапке, а её надо видеть.
  // #707176 даёт на белом 4.87:1, тогда как $color-disabled — 2.9:1.
  &--muted {
    color: #707176;
  }

  &__chevron {
    color: #707176;
    font-size: 12px;
  }
}
</style>
